import { Navigate, Outlet } from 'react-router-dom';
import { useAuthStore } from '../store/auth';

/**
 * Wraps the authenticated app: any user whose organization is still in
 * onboarding is bounced into the full-screen guided flow, so onboarding can't
 * be skipped by navigating straight to an app route. Runs inside ProtectedRoute,
 * so `user` is present.
 */
export function OnboardingGate() {
  const user = useAuthStore((s) => s.user);
  if (user?.organizationStatus === 'ONBOARDING') {
    return <Navigate to="/onboarding" replace />;
  }
  return <Outlet />;
}
